var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col text-center rounded-lg px-4 bg-brand-light-sand max-w-lg mx-auto"},[_c('div',{attrs:{"id":"inline-preview"}})])}]

export { render, staticRenderFns }